export default __webpack_public_path__ + "static/media/edit.df8f2686.svg";